import { useState } from 'react';
import useKey from './useKey';
var useKeyPress = function (keyFilter) {
    var _a = useState([false, null]), state = _a[0], set = _a[1];
    useKey(keyFilter, function (event) { return set([true, event]); }, { event: 'keydown' }, [state]);
    useKey(keyFilter, function (event) { return set([false, event]); }, { event: 'keyup' }, [state]);
    return state;
};
export default useKeyPress;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useKeyPress.js
// module id = RoOW
// module chunks = 0